import React, {useContext, useState} from 'react';
import {QuestionsContext} from '../context/questions';
import Option from './option';
import Fade from 'react-reveal/Fade';

const Question = ({item, isActive, data}) => {
    const {Question:title} = item;
    const {nextAction, clearList} = useContext(QuestionsContext);
    const [activeRadio, setRadio] = useState("");
    const Answers = Object.values(item.Answers[0]);
    const activeClass = isActive ? "active" : "" ;
    
    //set radio state for current question
    function chooseOption(event) {
        setRadio(event.target.value);
    }

    function submitAnswer() {
        const currentId = activeRadio.split("-")[1];
        const numberId = parseInt(currentId);

        const currentAnswer = Object.values(item.Answers[0]).find( function( option ){
            return option.id === numberId;
        } );

        const currentObject = currentAnswer.Options[0];


        // once you havedrilled down into the next question object, then call the "nextAction"with the actual question object
        nextAction(currentObject);
    }

    return <div className={`question ${activeClass}`} autoFocus>
        <Fade bottom>
            <div>
                <div className="titleArea">
                    <h2>{title}</h2>
                    {item.Description ?
                        <div dangerouslySetInnerHTML={{__html: item.Description }} />
                        :
                        ""
                    }
                </div>

                <div className="options">

                    {Answers.map((option, index) =>
                        (
                            option.id ?
                                <Option
                                    key={index}
                                    index={index}
                                    option={option}
                                    chooseOption={chooseOption}
                                    activeRadio={activeRadio}
                                    isActive={isActive}
                                />
                                :
                                ""
                        )
                    )}
                </div>

                {isActive ? 
                    <div className="utility-buttons">
                        <button 
                            className="su-button su-reset"
                            onClick={clearList} 
                            >
                            Reset
                        </button>
                        
                        <button 
                            className="su-button"
                            onClick={submitAnswer} 
                            disabled={!activeRadio}
                            >
                            Next
                        </button>

                    </div>
                    :
                    ""
                }
            </div>
        </Fade>
    </div>
    
}

export default Question;